export default "__VITE_ASSET__ComioQGq__"